export const TYPES = {
  INSTAGRAM: 'instagram',
  WHATSAPP: 'whatsapp',
  TELEGRAM: 'telegram',
  FACEBOOK: 'facebook',
  FACEBOOK_MESSENGER: 'facebook_messenger',
  VIBER: 'viber',
  MAIL: 'mail',
  VK: 'vk',
  MAX: 'max',
};

export const SERVER_TYPES = {
  EMAIL: TYPES.MAIL,
};

export const CHAIN_SERVICES = {
  EMAIL: 'email',
  TELEGRAM: 'telegram',
  VK: 'vk',
  WA_DIALOG: 'wa_dialog',
  APP_CHAT: 'app_chat',
  APP_CHAT_2: 'app_chat_2',
  MAX_BOT: 'max_bot',
};

export const MESSAGE_TYPES = {
  AUTO: 'auto',
  TEXT: 'text',
  IMAGE: 'image',
  VOICE: 'voice',
  DOCUMENT: 'document',
  VIDEO: 'video',
  NPS: 'nps',
  SERVICE_MENU: 'service_menu',
  SERVICE_GROUP: 'service_group',
};

export const TEMPLATE_TYPES = {
  MESSENGER: 'messenger',
  EMAIL: 'email',
};

export const TEMPLATES_SEARCH = {
  MIN_QUERY_LENGTH: 3,
  // короче слова бэк не ищет (CrmLevel::MailTemplateSearch::MIN_WORD_LENGTH)
  MIN_WORD_LENGTH: 2,
  DEBOUNCE_MS: 300,
  PAGE_SIZE: 50,
};

export const CHAIN_FIELDS_ERRORS = {
  hasTicketId: 'Не выбран тикет',
  hasMessage: 'Пустое сообщение',
  hasSubject: 'Пустая тема',
  hasFrom: 'Пустое поле адресата',
  hasNoShownSuggestion: 'Активный копайлот',
  forwardSubjectExist: 'Пустая тема',
  assignedManager: 'Нет менеджера у тикета',
};
